import { render, staticRenderFns } from "./RelationDrawer.vue?vue&type=template&id=5c7b19cb&scoped=true&"
import script from "./RelationDrawer.vue?vue&type=script&lang=js&"
export * from "./RelationDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b19cb",
  null
  
)

export default component.exports